import { IonBreadcrumbs, IonBreadcrumb, IonIcon, IonCard, IonCardTitle, IonCardHeader, IonButton, IonCardContent, IonInput, IonModal, IonTextarea, IonProgressBar, ItemReorderEventDetail, IonGrid, IonCol, IonRow, IonLabel, IonSegmentButton, IonSegment } from '@ionic/react';
import AppContainer from '../AppContainer';
import { chatbubbleEllipses } from 'ionicons/icons';
import Menu from '../components/Menu';
import { useLocation } from 'react-router';
import { useHistory } from 'react-router-dom';
import { useContext, useEffect, useState } from 'react';
import GlobalContext from '../domain/GlobalContext';
import { api } from '../domain/ApiService';
import { Assistant, Folder, Initiative, KnowledgeBaseItem, Prompt } from '../domain/Types';
import Chat from '../components/Chat';
import KnowledgeBase from '../components/KnowledgeBase';
import { appConfig } from '../domain/Config';
import Prompts from '../components/Prompts';
import React from 'react';

let assistantName: any = '';

const Page: React.FC = () => {

  const { user, initiative, getInitiative } = useContext(GlobalContext);
  const [ isFetched, setIsFetched ] = useState(false);
  const [showConfig, setShowConfig] = useState(false);
  const [showAssistantModal, setShowAssistantModal] = useState(false);
  const [ folder, setFolder ] = useState<Folder | null>(null);
  const [ assistant, setAssistant ] = useState<Assistant | null>(null);
  const [ templateAssistant, setTemplateAssistant ] = useState<Assistant | null>(null);
  const location = useLocation();
  const history = useHistory();
  const pathSegments = location.pathname.split('/').filter(Boolean);

  let folder_slug = "";
  let assistant_slug = "";

  if (pathSegments.length === 2)  {
    
    assistant_slug = pathSegments[1];
  } 
  else {

    folder_slug = pathSegments[1];
    assistant_slug = pathSegments[2];
  }

  useEffect(() => {

    setIsFetched(true);

    if (initiative != null) {

      let template = null;
      if (initiative.template_uid != null)
        template = getInitiative(initiative.template_uid);

      let assistants = initiative.assistants;
      let templateAssistants = null;
      
      if (template != null)
        templateAssistants = template.assistants;

      if (initiative.folders != null) {

        let fConfig = initiative.folders.find((f: Folder) => f.slug === folder_slug);
        let tfConfig = null;

        if (template != null && template.folders != null) {
          // TODO: Need to debug more & fix
          if (folder_slug && folder_slug === 'seo-copy-writer-assistant-see-keyword-below') {
            let slugVal = template.folders.findIndex(a => a.slug === 'seo-assistant');
            if (slugVal !== -1)
              folder_slug = 'seo-assistant';
          }
          template.folders.forEach((f: Folder) => {
            if ((folder_slug && folder_slug.includes(f.slug)) || (f.name && folder_slug && f.name.split(' ').filter(a => a).join('-').toLowerCase() === folder_slug)) {
              tfConfig = f;
            }
          });
          // tfConfig = template.folders.find((f: Folder) => f.name.split(' ').join('-').toLowerCase() === folder_slug);
        }
        if (fConfig) {

          setFolder(fConfig);
          if (fConfig != null && fConfig.assistants != null)
            assistants = fConfig.assistants;
          if (tfConfig != null && tfConfig['assistants'] != null)
            templateAssistants = tfConfig['assistants'];
        }
      }

      if (assistants != null) {

        let config = assistants.find((c: Assistant) => c.slug === assistant_slug)
        assistantName = config?.name;
        if (config != null)
          setAssistant(config);
      }

      if (templateAssistants != null) {
        let config;
        // let config = templateAssistants.find((c: Assistant) => c.slug === assistant_slug)
        templateAssistants.forEach((f: Assistant) => {
          if (assistant_slug.includes(f.slug) || f.name.split(' ').filter(a => a).join('-').toLowerCase() === assistant_slug) {
            config = f;
          }
        });
        if (config != null)
          setTemplateAssistant(config);
      }
    }

  }, [initiative, folder_slug, assistant_slug, getInitiative]);

  const updateInitiative = async () => {

    if (initiative != null) {

      try { 

        await api("/initiative/update", initiative, initiative) as Initiative; 
        window.dispatchEvent(new Event('initiativeUpdated'));
      }
      catch (err) { console.error('Error:', err); }
    }
  }

  const updateAssistant = async () => {

    if ((!initiative?.assistants && !folder?.assistants) || !assistant) return;

    setIsFetched(false);

    let config = undefined;
    if (initiative?.assistants && initiative?.assistants?.length)
      config = initiative.assistants.find((c: Assistant) => c.slug === assistant_slug)
    else if (folder?.assistants && folder?.assistants?.length)
      config = folder.assistants.find((c: Assistant) => c.slug === assistant_slug)

    if (config) {

      config.name = assistant.name;
      config.instructions = assistant.instructions;
      await updateInitiative();
    }
    setShowAssistantModal(false);    
    setIsFetched(true);
  };

  const navigateToParent = () => {
    const pathSegments = window.location.pathname.split('/').filter(Boolean);
    pathSegments.pop();
    const parentPath = `/${pathSegments.join('/')}`;
    history.push(parentPath);
  };

  const removeAssistant = async () => {

    setIsFetched(false);  

    if (initiative === null || initiative?.folders === null || !folder) { return; }

    const iFolder = initiative?.folders?.find(f => f.uid === folder.uid); 

    if (!iFolder) return;

    if (!iFolder.assistants)
      iFolder.assistants = [];
    
    iFolder.assistants = iFolder.assistants.filter(item => item.uid !== assistant?.uid);

    await updateInitiative();
    setShowAssistantModal(false);
    setAssistant(null);
    setIsFetched(true);
    navigateToParent();
  };
  
  const addToKnowledgeBase = (item: string | null, target: string | null, ) => {

    if (target === null)
      target = "assistant";

    if (assistant != null && folder != null && initiative != null && item != null) {      

      setIsFetched(false);
      let kBase = assistant.knowledge_base
      if (target === "folder")
         kBase = folder?.knowledge_base;
      else if (target === "initiative")
         kBase = initiative?.knowledge_base;

      if (!kBase || kBase === null)
          kBase = [];

      let kBaseItem = { "content": item, "source_assistant_uid": assistant?.uid } as KnowledgeBaseItem;
      kBase.push(kBaseItem);

      if (target === "folder")
         folder.knowledge_base = kBase;
      else if (target === "initiative")
         initiative.knowledge_base = kBase;
      else
         assistant.knowledge_base = kBase;

      updateInitiative();
    }

    setIsFetched(true);
  }

  const saveKnowledgeBase = (items: KnowledgeBaseItem[]) => {

    if (assistant != null) {

      setIsFetched(false);
      assistant.knowledge_base = items;
      updateInitiative();
      setIsFetched(true);
    }
  };

  const handleReorder = (event: CustomEvent<ItemReorderEventDetail>) => {
    event.detail.complete();
  }; 

  const [defaultMessage, setDefaultMessage] = React.useState('');
  const handlePromptClick = (item: Prompt | null) => {

    setDefaultMessage("");
    
    if (item) {

      const randomSpaces = ' '.repeat(Math.floor(Math.random() * 11));
      const messageWithSpaces = `${item?.content} ${randomSpaces}`;
      setDefaultMessage(messageWithSpaces);
    }
  }

  return (
    <>
      {(isFetched && initiative != null && initiative.initiative_type != null) ? (
      <>
      {(showConfig === false && !initiative.template) ? (
        <>          
          <IonGrid>
            <IonRow>
              <IonCol size="7">
                {(assistant != null) ? (
                <Chat 
                    assistant={assistant} 
                    defaultAssistantId={ (appConfig.initiativeAssistants as any)[initiative.initiative_type] }
                    addToKnowledgeBase={addToKnowledgeBase}
                    defaultMessage={defaultMessage}
                />
                ) : ( <></> )}
              </IonCol>
              <IonCol size="5">
                {user && (user.role === 'admin' || user.role === 'superadmin') && (
                  <IonButton className="basic" style={{ padding: "10px" }}  onClick={() => { setShowConfig(true); }}>Settings</IonButton>
                )}

                <div className="side-container">

                  <>
                    <Prompts assistant_uid={!assistant?.uid ? "-" : assistant.uid} showHeader={false} showActions={false} handleClick={handlePromptClick} />
                    <Prompts assistant_uid={!templateAssistant?.uid ? "-" : templateAssistant.uid} showHeader={false} showActions={false} handleClick={handlePromptClick} />
                  </>
                
                </div>
              </IonCol>
            </IonRow>
          </IonGrid>
        </>
      ) : (
        <>
        {!initiative.template ? 
        <IonButton onClick={() => { setShowConfig(false); }} className='basic' style={{marginLeft: "10px"}}>Back to chat room</IonButton>
      : <></>}
      <IonCard className='filled' style={{ padding: "10px" }}>
        <IonCardHeader>
          <IonCardTitle>Instructions</IonCardTitle>
          <br />              
          <big>{JSON.stringify(assistant?.instructions)}</big>
        </IonCardHeader>
        <IonCardContent>
          <IonButton className='basic' onClick={() => { setShowAssistantModal(true); }}>Modify</IonButton>
        </IonCardContent>
      </IonCard>

      <KnowledgeBase 
        items={assistant?.knowledge_base != null ? assistant?.knowledge_base : []} 
        templateItems={templateAssistant?.knowledge_base != null ? templateAssistant?.knowledge_base : []} 
        assistant_uid={assistant?.uid} 
        folder_uid={folder?.uid} 
        label="Chat room knowledge base"
        onSave={saveKnowledgeBase} />

      <IonCard className='filled' style={{ padding: "10px" }}>
        <IonCardHeader>
          <IonCardTitle>Cues</IonCardTitle>
        </IonCardHeader>
        <IonCardContent>
          <Prompts assistant_uid={assistant?.uid} showHeader={true} showActions={true} />
          {templateAssistant?.uid != null ? 
          <>
            <div className='mid-header'>From template</div>
            <Prompts assistant_uid={templateAssistant?.uid} showHeader={false} showActions={false} />
          </> 
          : <></> }

        </IonCardContent>
      </IonCard>

      <IonModal className='form-modal' isOpen={showAssistantModal} onDidDismiss={() => setShowAssistantModal(false)}>
          <div className='form'>              
              <div style={{height: "330px", paddingTop: "10px"}}>
                <div>
                  <IonInput
                    className='form-element'
                    label="Name"
                    labelPlacement="floating"
                    fill="outline"
                    value={assistant?.name} 
                    onIonChange={e => setAssistant(prev => prev ? { ...prev, name: e.detail.value! } : prev)}
                    placeholder="Name"
                  />              
                  <IonTextarea 
                    className='form-element'
                    label="Instruction"
                    labelPlacement="floating"
                    fill="outline"
                    rows={10}            
                    value={assistant?.instructions}
                    onIonChange={e => setAssistant(prev => prev ? { ...prev, instructions: e.detail.value! } : prev)}
                    placeholder="Instruction"
                  />
                </div>
              </div>
            <IonButton onClick={updateAssistant}>Save</IonButton>
            <IonButton className='basic' onClick={() => { setShowAssistantModal(false); }}>Cancel</IonButton>
            <IonButton color="danger" onClick={removeAssistant}>Remove</IonButton>

          </div>
        </IonModal>
        </>
      )}

      </>
      
      ) : (

        <IonProgressBar type="indeterminate" color="medium"></IonProgressBar>

      )}
    </>
  );
};

const Breadcrumb: React.FC = () => {
    const location = useLocation();
    const pathSegments = location.pathname.split('/').filter(Boolean);

    let assistant_slug = "";
  
    if (pathSegments.length === 2)  {
      
      assistant_slug = pathSegments[1];
    } 
    else {
  
      assistant_slug = pathSegments[2];
    }
  
    return (
      <IonBreadcrumbs>
        <IonBreadcrumb routerLink="/chat">
          <IonIcon slot="start" icon={chatbubbleEllipses}></IonIcon>
          Chat: {assistantName}
        </IonBreadcrumb>
      </IonBreadcrumbs>
    );
  };
  
const Container: React.FC<{}> = () => { return <AppContainer ContentComponent={Page} BreadcrumbComponent={Breadcrumb} MenuComponent={Menu} />; };
export default Container;